var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "prompt-content" }, [
    _c(
      "div",
      { staticClass: "prompt-content-area" },
      _vm._l(_vm.object, function(value, key) {
        return _c("div", { key: key, staticClass: "prompt-item" }, [
          key !== "_id" && key !== "__v"
            ? _c("div", { staticClass: "prompt-value" }, [
                _vm._v(_vm._s(key) + " :")
              ])
            : _vm._e(),
          _vm._v(" "),
          key !== "_id" && key !== "__v"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.object[key],
                    expression: "object[key]"
                  }
                ],
                staticClass: "prompt-input",
                attrs: { type: "text" },
                domProps: { value: _vm.object[key] },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.object, key, $event.target.value)
                  }
                }
              })
            : _vm._e()
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "prompt-buttons" }, [
      _c("div", { staticClass: "prompt-button", on: { click: _vm.submit } }, [
        _vm._v("确认")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "prompt-button", on: { click: _vm.cancel } }, [
        _vm._v("取消")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9bca5d18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bca5d18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prompt.vue
// module id = null
// module chunks = 